import type { CSSProperties, ReactNode } from "react";
import React from "react";

import { Link } from "react-router";
import styled from "styled-components";

import { colorTheme } from "@utils";

const Name = styled.div<{
  $hasPermission: boolean;
  $noUnderline: boolean;
}>`
  color: ${({ $hasPermission }) => $hasPermission && colorTheme("primary")};

  &:hover {
    cursor: ${({ $hasPermission }) => $hasPermission && "pointer"};
    text-decoration: ${({ $noUnderline, $hasPermission }) =>
      $noUnderline || !$hasPermission ? null : "underline"};
  }
`;

interface TableLinkProps {
  url?: string;
  onClick?: () => void;
  hasPermission?: boolean;
  noUnderline?: boolean;
  children?: ReactNode;
  newTab?: boolean;
  testId?: string;
  style?: CSSProperties;
}

interface DisplayLinkProps {
  hasPermission: boolean;
  onClick?: () => void;
  noUnderline: boolean;
  testId?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

const DisplayLink = ({
  hasPermission,
  onClick,
  noUnderline,
  testId,
  style,
  children,
  ...props
}: DisplayLinkProps) => (
  <Name
    {...props}
    style={style}
    $hasPermission={hasPermission}
    onClick={hasPermission ? onClick : undefined}
    $noUnderline={noUnderline}
    data-testid={testId}
  >
    {children}
  </Name>
);

const TableLink = ({
  url,
  onClick,
  hasPermission = true,
  noUnderline = false,
  children,
  newTab,
  testId,
  style,
  ...props
}: TableLinkProps) => {
  if (url && hasPermission) {
    if (newTab) {
      return (
        <a
          target="_blank"
          rel="noreferrer"
          href={url}
          style={{ textDecoration: "none" }}
          onClick={(e) => e.stopPropagation()}
        >
          <DisplayLink
            {...props}
            hasPermission={hasPermission}
            onClick={onClick}
            noUnderline={noUnderline}
            testId={testId}
            style={style}
          >
            {children}
          </DisplayLink>
        </a>
      );
    }

    return (
      <Link
        style={{ textDecoration: "none" }}
        to={url}
        onClick={(e) => e.stopPropagation()}
      >
        <DisplayLink
          {...props}
          hasPermission={hasPermission}
          onClick={onClick}
          noUnderline={noUnderline}
          testId={testId}
          style={style}
        >
          {children}
        </DisplayLink>
      </Link>
    );
  }

  return (
    <DisplayLink
      {...props}
      hasPermission={hasPermission}
      onClick={onClick}
      noUnderline={noUnderline}
      testId={testId}
      style={style}
    >
      {children}
    </DisplayLink>
  );
};

export default TableLink;
